export default "__VITE_ASSET__BewgwuHX__"